import styled from 'styled-components';

export const SelectorsContainer = styled.div`
  display: flex;
`;

export const SelectorTab = styled.div`
  display: flex;
  width: 120px;
  padding: 8px 50px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${props => (props.isSelected ? '#0070CD' : '#484848')};
  cursor: ${props => (props.isSelected ? 'unset' : 'pointer')};
  background-color: ${props => (props.isSelected ? '#E5F1FF' : '#fff')};
  border: 1px solid ${props => (props.isSelected ? '#0070CD' : '#D9DBDF')};
  &:first-child {
    border-radius: 8px 0px 0px 8px;
  }
  &:last-child {
    border-radius: 0px 8px 8px 0px;
  }
`;

export const SelectorLabel = styled.p`
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`;
